import React from 'react';
import './LinksPage.css';

const LinksPage: React.FC = () => {
  const partnerLinks = [
    {
      name: 'Hillcrest Baptist Church',
      url: 'http://www.hbcacworth.org/',
      description: 'Our church home in Acworth, Georgia'
    },
    {
      name: 'True Life Baptist Church',
      url: 'https://www.truelife.org/',
      description: 'Partner church supporting our ministry'
    },
    {
      name: 'Basic Bible Course',
      url: 'http://www.basicbiblecourse.org/',
      description: 'Free online Bible study resources'
    },
    {
      name: 'e-Sword',
      url: 'http://www.e-sword.net/',
      description: 'Free Bible study software and resources'
    }
  ];

  return (
      <div className="links-page">
        <div className="container">
          <h1>Partner Organizations & Resources</h1>
          <p className="intro-text">
            The Outreach Bible Project partners with various organizations and ministries 
            to spread the Gospel and provide valuable resources for Bible study and Christian growth.
          </p>
          
          <div className="partners-grid">
            {partnerLinks.map((partner, index) => (
              <div key={index} className="partner-card">
                <h3>{partner.name}</h3>
                <p>{partner.description}</p>
                <a 
                  href={partner.url} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="partner-link"
                >
                  Visit Website →
                </a>
              </div>
            ))}
          </div>

          <div className="additional-resources">
            <h2>Additional Resources</h2>
            <div className="resources-section">
              <h3>Bible Study Tools</h3>
              <ul>
                <li>Free Bible study courses and materials</li>
                <li>Digital Bible software and commentaries</li>
                <li>Online scripture memorization tools</li>
                <li>Christian discipleship resources</li>
              </ul>
              
              <h3>Ministry Support</h3>
              <ul>
                <li>Local church partnerships</li>
                <li>Evangelism training and materials</li>
                <li>Community outreach programs</li>
                <li>International missions support</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
  );
};

export default LinksPage;
